import { Autocomplete, Box, Button, Checkbox, ClickAwayListener, Divider, FormControlLabel, FormGroup, Paper, Popper, TextField, Typography } from '@mui/material'
import { RELATIONSHIP_DEFS } from '~/map/map-inspector/use-map-crops-styles'

const FILTER_TYPES = [
  'template-companion',
  'family-companion',
  'family-incompatible',
  'template-incompatible',
]

export const CropFilterPopper = ({
  anchorEl,
  crops,
  filterCropId,
  setFilterCropId,
  activeFilters,
  setActiveFilters,
  onClickAway,
}) => {
  const open = Boolean(anchorEl)

  const selectedCrop = crops.find(c => c.id === filterCropId) ?? null

  const handleCropChange = (_, newValue) => {
    setFilterCropId(newValue?.id ?? null)
  }

  const handleFilterToggle = (rel) => {
    setActiveFilters(prev =>
      prev.includes(rel) ? prev.filter(r => r !== rel) : [...prev, rel]
    )
  }

  return (
    <Popper open={open} anchorEl={anchorEl} placement="bottom-start" sx={{ zIndex: 1400, userSelect: 'none' }}>
      <ClickAwayListener onClickAway={onClickAway}>
        <Paper elevation={4} sx={{ p: '1rem', width: 280, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <Typography variant="body2" fontWeight={600}>Filter by companion relationship</Typography>

          <Autocomplete
            size="small"
            options={crops}
            value={selectedCrop}
            onChange={handleCropChange}
            getOptionLabel={(c) => c.name}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            slotProps={{ popper: { sx: { zIndex: 1500 } } }}
            renderInput={(params) => <TextField {...params} label="Active crop" />}
          />

          <Divider />

          <Typography variant="caption" color="text.secondary">
            Show crop species that are:
          </Typography>

          <FormGroup sx={{ gap: '0.1rem', userSelect: 'none' }}>
            {FILTER_TYPES.map((rel) => {
              const def = RELATIONSHIP_DEFS[rel]
              return (
                <FormControlLabel
                  key={rel}
                  control={
                    <Checkbox
                      size="small"
                      checked={activeFilters.includes(rel)}
                      onChange={() => handleFilterToggle(rel)}
                      disabled={!filterCropId}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {def.icon} {def.label}
                    </Typography>
                  }
                />
              )
            })}
          </FormGroup>
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}
